export default "__VITE_ASSET__CjK8Ah_G__"